<img [src]="userService.companyLogoBottom" />
<!--<img *ngIf="veeam" src="assets/icon/veeam-text.svg" />-->
<div class="copyright">{{ "__COMPONENTS_FOOTER_COPYRIGHT__" | translate }}</div>
